import React from 'react';
import { Box, Spinner, Center, Text, VStack } from '@chakra-ui/react';
import { useStateContext } from '../context/ContextProvider';

const Loader = () => {
  const { isLoading } = useStateContext();

  if (!isLoading) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      backgroundColor="rgba(0, 0, 0, 0.4)"
      backdropFilter="blur(4px)"
      zIndex="9999"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={4}>
        <Center
          p={8}
          bg="white"
          borderRadius="2xl"
          boxShadow="2xl"
          _dark={{ bg: "gray.800" }}
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="purple.500"
            size="xl"
          />
        </Center>
        <Text
          color="white"
          fontWeight="bold"
          fontSize="lg"
          textShadow="0 2px 4px rgba(0,0,0,0.3)"
        >
          Chargement en cours...
        </Text>
      </VStack>
    </Box>
  );
};

export default Loader;
